import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetAllTE_PM_NatureOfWork = createAsyncThunk(
  "dropdowns/GetAllTE_PM_NatureOfWork",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllTE_PM_NatureOfWork"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownTENatureOfWork = createSlice({
  name: "DropDownTENatureOfWork",
  initialState: {
    DropDownTENatureOfWork: [],
    loadingDropDownTENatureOfWork: false,
    errorDropDownTENatureOfWork: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllTE_PM_NatureOfWork.pending, (state, action) => {
        state.loadingDropDownTENatureOfWork = true;
        state.DropDownTENatureOfWork = action.payload;
        state.errorDropDownTENatureOfWork = null;
      })
      .addCase(GetAllTE_PM_NatureOfWork.fulfilled, (state, action) => {
        state.loadingDropDownTENatureOfWork = false;
        state.DropDownTENatureOfWork = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllTE_PM_NatureOfWork.rejected, (state, action) => {
        state.loadingDropDownTENatureOfWork = false;
        state.errorDropDownTENatureOfWork = action.payload;
      });
  },
});

export default DropDownTENatureOfWork.reducer;
